"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    close: "close",
    searchButton: "Search",
    searchPlaceholder: "Enter a domain to get started",
    invalidDomain: "The domain you entered isn't valid.",
};
